// Canonical public JWKS URL, built from the configured backend origin.
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "https://api.herdsafe.ai").replace(/\/$/, "");
export const JWKS_URL = `${BACKEND}/.well-known/herdsafe-keys.json`;
